import { FC, ReactNode, useMemo } from 'react'
import cn from 'classnames'
import styles from 'components/features/pfm/FloatingPaneFooter/FloatingPaneFooter.styl'
import Button, { ButtonTheme } from 'components/features/pfm/Button/Button'

export type ButtonAction = {
  action: () => void
  text: string
}

export type FloatingPaneFooterProps = {
  className?: string
  isLoading?: boolean

  primaryButton?: ReactNode | null
  secondaryButton?: ReactNode | null
  tertiaryButton?: ReactNode | null

  onAction?: () => void
  actionName?: string
  actionTheme?: ButtonTheme
  actionDisabled?: boolean

  onCancel?: (() => void) | null
  cancelName?: string
  cancelTheme?: ButtonTheme
}

export const FloatingPaneFooter: FC<FloatingPaneFooterProps> = (props) => {
  const {
    className,
    isLoading,

    primaryButton,
    secondaryButton,
    tertiaryButton,

    onCancel,
    cancelName = 'Cancel',
    cancelTheme,

    // TODO: Replace 'action' related props with 'primaryButton' in all Panes
    onAction,
    actionName,
    actionTheme = 'blue',
    actionDisabled,
  } = props

  const primaryButtonChild = useMemo(() => {
    if (!!primaryButton) {
      return primaryButton
    } else if (!onAction || !actionName) {
      return null
    }
    // TODO: Replace all 'action' related props with 'primaryButton' in all Panes
    return (
      <Button
        fullWidth
        isSubmitting={ isLoading }
        onClick={ onAction }
        text={ actionName }
        theme={ actionTheme }
        iconSlug={ actionTheme === 'golden' ? 'lock' : undefined }
        disabled={ actionDisabled }
      />
    )
  }, [actionDisabled, actionName, actionTheme, isLoading, onAction, primaryButton])

  const tertiaryButtonChild = useMemo(() => {
    if (!!tertiaryButton || tertiaryButton === null) {
      return tertiaryButton
    } else if (!onCancel) {
      return null
    }
    // TODO: Make all panes use the 'tertiaryButton' instead of 'onCancel'
    return (
      <Button
        fullWidth
        size='small'
        qaMarker='cancel'
        text={ cancelName }
        theme={ cancelTheme }
        style={ !!cancelTheme ? undefined : 'textOnly' }
        onClick={ onCancel }
      />
    )
  }, [cancelName, cancelTheme, onCancel, tertiaryButton])

  const footerClassNames = cn(
    className,
    styles.floatingPaneFooter, {
      [styles.noCta]: !actionName && cancelTheme === 'textOnly',

      // Hacky way of disabling buttons. Should be directly via their 'disabled' prop
      [styles.disabled]: isLoading,
    }
  )

  return (
    <div className={ footerClassNames }>
      { primaryButtonChild }
      { secondaryButton }
      { tertiaryButtonChild }
    </div>
  )
}
